<script setup lang="ts">
import type { AnalyticsFilters } from '@/shared/lib';

import AnalyticsPeriodFilter from './AnalyticsPeriodFilter.vue';

const props = defineProps<{
  filters: AnalyticsFilters;
  timezone: string;
  comparison?: boolean;
}>();
const emit = defineEmits<{ change: [filters: AnalyticsFilters] }>();
</script>

<template>
  <div class="max-w-[55vw] min-w-0 sm:max-w-[65vw] lg:max-w-[min(56vw,46rem)]">
    <AnalyticsPeriodFilter
      v-bind="props"
      @change="emit('change', $event)"
    />
  </div>
</template>
